import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-tab',
  templateUrl: './login-tab.component.html',
  styleUrl: './login-tab.component.css'
})

export class LoginTabComponent {
  #auth = inject(AuthService);
  #router = inject(Router);

  constructor(){
    this.#logInComprobation();
  }
  #logInComprobation(){
    if(this.#auth.isLogIn()){
      this.#router.navigate(['/app'])
    }
  }

  passwordView = false;
  formLogIn = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  loginUser(){
    if(this.formLogIn.valid){
      const email = (this.formLogIn.controls['email'].value).toLowerCase(); 
      const password = this.formLogIn.controls['password'].value;
      this.#auth.logIn(email, password).subscribe( res =>{
        const Toast = Swal.mixin({
          toast: true,
          position: 'center',
          showConfirmButton: false,
          timer: 800,
          timerProgressBar: true,
          willClose: (toast) =>{
            this.#router.navigate(['/app']);
          }
        });

        Toast.fire({
          icon: 'success',
          title: 'Sesión iniciada'
        });
      }, err=>{
        Swal.fire({
          title: 'Error',
          text: 'Credenciales incorrectas',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      });
    }
  }
  showPassword(){
    this.passwordView = !this.passwordView;
    const elem = document.getElementById('pass');
    if(this.passwordView){
      elem['type'] = 'text';
    }else{
      elem['type'] = 'password';
    }
  }
}
